import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { filter, switchMap, tap } from 'rxjs';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';
import { TosterService } from 'src/app/core/services/toster/toster.service';

@Component({
  selector: 'app-delete-aaset',
  templateUrl: './delete-aaset.component.html',
  styleUrls: ['./delete-aaset.component.scss']
})
export class DeleteAasetComponent implements OnInit {

  showData: any;
  public isLoading: boolean;

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA,) public data: {},
    private bottomsheet: MatBottomSheetRef<DeleteAasetComponent>,
    private assetService: AssetService,
    private toasterService: TosterService) { }

  ngOnInit(): void {
    this.showData = this.data;
    console.log("Data :", this.data)
  }

  deleteAsset() {
    this.assetService.hasLinkToAnyOpenJobs(this.data["assetId"]).pipe(
      tap(hasOpenJobs => {
        if (hasOpenJobs) {
          this.toasterService.error("This asset is linked to an open Job(s), Please mark the Job(s) as complete or deactivate it before deleting the asset.");
          this.bottomsheet.dismiss();
        }
      }),
      filter(hasOpenJobs => !hasOpenJobs),
      switchMap(() => this.assetService.deleteAsset(this.data["propertyId"], this.data["assetId"]))
    ).subscribe({
      next: (res) => {
        if (res) {
          this.isLoading = false;
          this.toasterService.success(
            'Asset deleted successfully from the Property'
          );
          this.bottomsheet.dismiss(true);
        }
      }, error(err) {
        this.isLoading = false;
        this.toasterService.warning(
          'Asset deleted unsuccessful'
        );
      },
    });
  }

  cancel() {
    this.bottomsheet.dismiss();
  }
}
